import type { ITriggerRule } from "../../interfaces/Widgets";

const sortedEntries = (config: Record<string, string> | undefined) =>
  Object.entries(config ?? {}).sort(([a], [b]) => a.localeCompare(b));

/** Execution identity, independent of labels and object key insertion order. */
export const ruleIdentity = (rule: ITriggerRule): string =>
  JSON.stringify([
    rule.id,
    rule.event,
    sortedEntries(rule.eventConfig),
    rule.action,
    sortedEntries(rule.actionConfig),
    !!rule.once,
  ]);
